<template>
  <div class="reading-toggle-outside">
    <input 
      id="toggleReading" 
      v-model="showReading"
      type="checkbox" 
    >
    <label for="toggleReading">Show reading</label>
  </div>
  <div
    class="flashcard-container"
    data-test="flashcard-component"
    @click="handleCardClick"
  >
    <div
      class="flashcard"
      :class="{ 'flipped': isFlipped }"
    >
      <div 
        class="flashcard-front"
      >
        <span 
          v-if="showReading && card.reading" 
          class="reading"
        > 
          ({{ card.reading }})
        </span>
        <div class="content">
          {{ card.word }}
        </div>
      </div>
      <div 
        class="flashcard-back"
      >
        <span 
          v-if="!showReading && card.reading" 
          class="reading reading-back"
        > 
          ({{ card.reading }})
        </span>
        <div class="content">
          {{ card.definition }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        card: {
            type: Object,
            required: true,
            validator: (value) => value.word && value.definition,
        },
    },
    data() {
      return {
        showReading: true,
        isFlipped: false,
        isMobile: window.innerWidth <= 599,
      };
    },
    watch: {
      card() {
        this.isFlipped = false;
      }
    },
    mounted() {
      window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      handleResize() {
        this.isMobile = window.innerWidth <= 599;
      },
      handleCardClick() {
        if (this.isMobile) {
          this.isFlipped = !this.isFlipped;
        }
      }
    }
};
</script>

<style scoped>
.flashcard {
  position: relative;
  width: 600px;
  height: 400px;
	transition: 0.5s;
	transform-style: preserve-3d;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
}

@media (min-width: 600px) {
  .flashcard {
    margin: 30px auto;
  }

  .flashcard-container:hover .flashcard {
    transform: rotateY(180deg);
  }
}

@media (max-width: 599px) {
  .flashcard {
    width: 100%;
    height: 280px;
    margin: 20px auto;
    cursor: pointer;
  }

  .flashcard.flipped {
    transform: rotateY(180deg);
  }
}

.flashcard-container, .flashcard-front, .flashcard-back {
  position: relative;
  width: 500px;
  height: 400px;
	transition: 0.5s;
	transform-style: preserve-3d;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 100px auto;
  margin-top: 20px;
}

@media (max-width: 599px) {
  .flashcard-container, .flashcard-front, .flashcard-back {
    width: 100%;
    height: 280px;
    margin: 40px auto;
    padding: 0 16px;
  }
}

.flashcard-front,
.flashcard-back {
  backface-visibility: hidden;
  border: 1px solid rgba(27,30,100,0.10);
  border-radius: var(--radius-lg);
  margin: auto;
  text-align: center;
	position: absolute;
	top: 0;
	left: 0;
}

.flashcard-front {
  display: flow;
  align-content: center;
  z-index: 5;
}

.flashcard-back {
  display: flow;
  align-content: center;
  transform: rotateY(180deg);
}

.flashcard-container {
  margin-top: 50px;
  margin-bottom: 50px;
}

@media (max-width: 599px) {
  .flashcard-container {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.content{
  font-size: clamp(24px, 5vw, 40px);
  padding: 20px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.reading {
  font-size: clamp(14px, 3vw, 18px);
  color: var(--color-text-secondary);
  display: block;
  margin-bottom: 10px;
}

@media (max-width: 599px) {
  .reading {
    margin-bottom: 5px;
  }
}

.reading-back {
  margin-bottom: 10px;
}

.reading-toggle-outside {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  margin: 16px auto;
  max-width: 600px;
}

@media (max-width: 599px) {
  .reading-toggle-outside {
    max-width: 100%;
    padding: 12px 16px;
    margin: 12px 16px;
  }
}

.reading-toggle-outside input {
  cursor: pointer;
}

.reading-toggle-outside label {
  cursor: pointer;
  font-size: 14px;
}
</style>    